import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { MuException } from 'src/app/components/shared/types/exception.type';
import { FileUpload } from 'primeng/fileupload';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { v4 as uuidv4 } from 'uuid';
import { fileFormatsAllowedToUpload } from 'src/app/components/massive/models/filesFormatAllowedToUpload';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-file-upload-form',
  templateUrl: './file-upload-form.component.html',
  styleUrls: ['./file-upload-form.component.sass'],
})
export class FileUploadFormComponent<FlagType> extends MuComponent {
  @Output() fileEvent = new EventEmitter<File>();
  @Input() formData: UntypedFormGroup;
  @Input() flagList: Flags<FlagType>;
  @Input() uploadFileFlag: FlagType;

  fileUploaded: boolean;
  fileId: string;
  fileFormatsAllowedToUpload = fileFormatsAllowedToUpload.toString();
  file: File;
  fileControl: FileUpload;

  private formBuilder: UntypedFormBuilder;

  constructor(private injector: Injector) {
    super();
    this.formBuilder = this.injector.get<UntypedFormBuilder>(UntypedFormBuilder);
    this.fileUploaded = false;
  }

  muOnInit(): void {
    this.fileId = uuidv4();
  }

  /**
   * called to enable the create service button
   * @returns void
   */
  handleFilePending(): void {
    this.fileUploaded = false;
  }

  /**
   *
   * @param {FileUpload} control
   * @param $event
   * @returns Promise<void>
   */
  async eventLoadExcelFile(control: FileUpload, $event): Promise<void> {
    this.fileControl = control;
    try {
      this.setFile($event.files[0]);
    } catch (e) {
      control.clear();
      throw new MuException(e);
    }
  }

  /**
   *
   * @param {FileUpload} control
   * @returns void
   */
  cancelLoad(control: FileUpload): void {
    this.deleteFile();
    control.clear();
  }

  /**
   * set uploaded file
   * @param {File} file `
   * @returns void
   */

  setFile(file: File): void {
    this.file = file;
    this.formData.patchValue({
      file: file,
    });
    this.fileUploaded = true;
  }

  /**
   * Delete the loaded file
   * @returns void
   */
  deleteFile(): void {
    this.formData.patchValue({
      file: null,
    });
    this.file = null;
    this.fileUploaded = false;
  }

  muOnDestroy(): void {
    /** */
  }
}
